import { Box, Button } from '@qbe/ads-core';
import React, { useState } from 'react';

import { TRIGGER_MFE_CREDIT_CARD_SUBMIT } from '~/constants/events';
import { useAppContent, useAppSelector } from '~/hooks';

import CreditCardForm from './CreditCardForm';

const CreditCardContainer = ({ onSubmitPayment }: { onSubmitPayment: () => Promise<unknown> }) => {
  const { getTextContent: getPaymentsContent } = useAppContent({ basePath: 'dsme.payments' });
  const [isFormReady, setIsFormReady] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const isPaymentInProgress = useAppSelector(
    (state) => state.payments?.isPaymentInProgress ?? false
  );

  const handleButtonClick = () => {
    // Guard: prevent double-click while processing
    if (isPaymentInProgress) return;

    // Dispatch event to iframe
    window.dispatchEvent(new Event(TRIGGER_MFE_CREDIT_CARD_SUBMIT));
  };

  const handleFormStateChange = (state: { isReady: boolean; isValid: boolean }) => {
    setIsFormReady(state.isReady);
    setIsFormValid(state.isValid);
  };

  return (
    <Box>
      <CreditCardForm onFormStateChange={handleFormStateChange} onSubmitPayment={onSubmitPayment} />
      {isFormReady && (
        <Box textAlign="center">
          <Button
            type="button"
            label={getPaymentsContent('buttons.buyNow')}
            onClick={handleButtonClick}
            disabled={!isFormValid || isPaymentInProgress}
            data-track="Buy Now - btn credit card"
          />
        </Box>
      )}
    </Box>
  );
};

export default CreditCardContainer;
